<div class="container-fluid p-3 onboarding-wrapper">
    <div class="topbar d-flex justify-content-between align-items-center flex-wrap mx-2">
        
        <div class="mx-2">
            <h2 class="title">Onboarding Overview</h2>
            <p class="subtitle">Monitor and manage employee onboarding lifecycle.</p>
        </div>

        <div class="controls d-flex align-items-center gap-2 flex-wrap">
        </div>

        <button class="btn-new">
            + New Employee
        </button>
    </div>

    <div class="row g-3 mb-4">
        <div class="col" *ngFor="let stat of stats">
            <div class="card stat-card text-center">
                <div class="card-body">
                    <div class="stat-icon mb-2">
                        <i [class]="stat.icon"></i>
                    </div>
                    <h6 class="mt-1" style="font-size: 14px; font-weight: 600; color: rgb(97, 96, 96);">{{ stat.title }}</h6>
                    <h4 [class]="stat.trendClass">{{ stat.value }}</h4>
                    <!-- <small [ngClass]="stat.trendClass">{{ stat.trend }}</small> -->
                </div>
            </div>
        </div>
    </div>

    <div class="row g-4">

        <div class="col-lg-8">
            <div class="card mb-4">
                <div class="card-body">
                    <h6 class="mb-4">Onboarding Funnel</h6>
                    <div class="d-flex justify-content-between text-center funnel">
                        <div *ngFor="let step of funnel">
                            <div class="circle" [ngClass]="step.class">{{ step.step }}</div>
                            <div style="font-size: 14px;" class="mt-2 fw-semibold">{{ step.label }}</div>
                            <small>{{ step.count }}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-between mb-3">
                        <h6>Recent Onboarding Activity</h6>
                        <!-- <a href="#">View All</a> -->
                    </div>

                    <table class="table align-middle">
                        <thead>
                            <tr>
                                <th>Employee</th>
                                <th>Role</th>
                                <th>Branch</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let emp of employees">
                                <td class="d-flex align-items-center">
                                    <img [src]="emp.avatar" class="avatar me-2">
                                    <div>
                                        <strong>{{ emp.name }}</strong><br>
                                        <small>{{ emp.id }}</small>
                                    </div>
                                </td>

                                <td>{{ emp.role }}</td>
                                <td>{{ emp.branch }}</td>

                                <td>
                                    <span class="badge" [ngClass]="{
                          'bg-success': emp.status=='Completed',
                          'bg-warning text-dark': emp.status=='Pending',
                          'bg-primary': emp.status=='In Progress'
                        }">
                                        {{ emp.status }}
                                    </span>
                                </td>

                                <td>{{ emp.date }}</td>
                                <td><i class="bi bi-eye"></i></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

        </div>

        <div class="col-lg-4">
            <!-- <div class="card mb-4">
        <div class="card-body">
          <h5>Quick Actions</h5>
          <div class="row g-1 mt-2">
            <div class="col-6" *ngFor="let action of actions">
              <button class="btn btn-light action-btn">
                <i [class]="action.icon"></i><br>
                {{ action.label }}
              </button>
            </div>
          </div>
        </div>
      </div> -->

            <div class="card mb-4">
                <div class="card-body">
                    <h6 class="mb-3">Age Distribution</h6>
                    <hr>
                    <div *ngFor="let age of ages" class="mb-3">
                        <div class="d-flex justify-content-between">
                            <small>{{ age.label }}</small>
                            <small>{{ age.value }}%</small>
                        </div>
                        <div class="progress">
                            <div class="progress-bar" [style.width.%]="age.value"></div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <h6 class="mb-3">Critical Alerts</h6>
                    <hr>
                    <div class="mt-1" *ngFor="let alert of alerts" class="alert-box" [ngClass]="alert.class">
                        <strong>{{ alert.title }}</strong>
                        <p style="font-size: 14px;" class="mb-0">{{ alert.desc }}</p>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>